/**
 * Piccole regole sui biglietti comprati sul sito, uguali per la funzione
 * evento-pubblico, per il motore delle email e per Pixel (alias @eventi).
 */

type Oggetto = Record<string, unknown>;
const oggetto = (v: unknown): v is Oggetto => typeof v === 'object' && v !== null && !Array.isArray(v);

/** Il nome del prodotto dalla riga dell'ordine (ordini_sito.righe). */
export function nomeProdottoDellaRiga(righe: unknown, rigaId: unknown): string {
  const riga = Array.isArray(righe) ? righe.find((r) => oggetto(r) && Number(r.riga_id) === Number(rigaId)) : null;
  const nome = oggetto(riga) && typeof riga.nome === 'string' ? riga.nome.trim() : '';
  return nome || 'Biglietto';
}

/**
 * Il tipo di biglietto dal nome del prodotto sul sito:
 * "Congressista biglietto ingresso convegno HS&UT" -> "Congressista",
 * "Workshop Larry Wilson biglietto ingresso - 5 novembre" -> "Workshop Larry Wilson".
 */
export function tipoBiglietto(nomeProdotto: string): string {
  const prima = nomeProdotto.split(/\s+biglietto\b/i)[0].trim();
  return prima || nomeProdotto.trim() || 'Biglietto';
}
